import React, { useState,useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FetchFunc from '../API';
import YourDetailsForm from './Yourdetails';
// import Paymentdetail from './CheckoutForm';
import Header from '../Header';
import './Purchasereport.css';
import check from '../asset/Check_fill.png';
import back from '../asset/Expand_left.png';
import Payment from './Payment';
import authorityLetterTemplate from '../asset/Letter_of_Authority_English_Template.docx';


// const Backend_url = 'http://localhost:8080';
// const Backend_url = '/api';
const Backend_url = process.env.REACT_APP_BACKEND_URL || '/api';
const PARTNER_BASE_PRICE = 199;
const PARTNER_DOCUMENT_MAX_BYTES = 10 * 1024 * 1024;

const getReportLabel = (reportType) => {
    if (reportType === 'Strata Report') {
        return 'Strata Report';
    }
    return 'Building & Pest Report';
};

const getReportEta = (reportType) => {
    if (reportType === 'Strata Report') {
        return '3-5 working days';
    }
    return '2-3 working days';
};

const getReportCode = (reportType) => {
    if (reportType === 'Strata Report') {
        return 'STRATA';
    }
    return 'BUILDING';
};

const getRoleFromSearch = (search) => {
    const roleParam = new URLSearchParams(search).get('role');
    const allowedRoles = {
        partner: 'Partner',
        customer: 'Customer',
        admin: 'Admin',
    };

    return allowedRoles[roleParam?.toLowerCase()] || null;
};

const StepOne = ({ showStepTwo, updatePaymentSummary,formPurchase, onUpdate, role }) => {
    const isReportOk = localStorage.getItem('reportOK') === 'true';
    const [hasGrannyFlat, setHasGrannyFlat] = useState(formPurchase.grannyFlat);
    const [errors, setErrors] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');

    const validateCustomerField = (name, value, relatedValue) => {
        let error = '';
        const requiredFields = ['firstName', 'lastName', 'homeAddress', 'mobile'];
        if (requiredFields.includes(name) && !value) {
            error = 'This field is required';
            return error;
        }

        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                error = 'Invalid email format';
            }
        } 
        // else if (name === 'mobile') {
        //     const mobileRegex = /^(\+61|0)4\d{8}$/;
        //     if (!mobileRegex.test(value)) {
        //         error = 'Invalid mobile number';
        //     }
        // } 
        else if (name === 'confirmEmail') {
            if (value !== relatedValue) {
                error = 'Emails do not match';
            }
        }
        // console.log(`Validation result for ${name}: ${error}`);
        return error;
    };

    const validatePartnerField = (name, value) => {
        let error = '';
        const requiredFields = ['agentFirstName', 'agentLastName', 'agentMobile', 'agentEmail', 'reportType'];
        if (requiredFields.includes(name) && !value) {
            error = 'This field is required';
            return error;
        }

        if (name === 'agentEmail') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                error = 'Invalid email format';
            }
        } 
        // else if (name === 'agentMobile') {
        //     const mobileRegex = /^(\+61|0)4\d{8}$/;
        //     if (!mobileRegex.test(value)) {
        //         error = 'Invalid mobile number';
        //     }
        // } 
        else if (name === 'reportType') {
            const validTypes = ['Pest Report', 'Strata Report'];
            if (value && !validTypes.includes(value)) {
                error = 'Please select a valid report type';
            }
        }
        // console.log(`Validation result for ${name}: ${error}`);
        return error;
    };

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
    };
    const handleCustomerClick = (e) => {
        e.preventDefault();
        const newErrors = {};
        let isValid = true;
        Object.keys(formPurchase).forEach((key) => {
            const relatedValue = key === 'confirmEmail' ? formPurchase.email : null;
            const error = validateCustomerField(key, formPurchase[key], relatedValue);
            if (error) {
                isValid = false;
                newErrors[key] = error;
            }
        });
        if(formPurchase['email'] !== confirmEmail) {
            isValid = false;
            newErrors['confirmEmail'] = 'Emails do not match';
        }
        setErrors(newErrors);
        // console.log(newErrors)
        if (isValid) {
            // console.log('Data saved:', formPurchase);
            showStepTwo();
            scrollToTop();
        } else {
            // console.log('Form has errors:', newErrors);
        }        
    };

    const handlePartnerClick = (e) => {
        e.preventDefault();
        const newErrors = {};
        let isValid = true;
        Object.keys(formPurchase).forEach((key) => {
            const error = validatePartnerField(key, formPurchase[key]);
            if (error) {
                isValid = false;
                newErrors[key] = error;
            }
        });
        setErrors(newErrors);
        // console.log(newErrors)
        if (isValid) {
            // console.log('Data saved:', formPurchase);
            showStepTwo();
            scrollToTop();
        } else {
            // console.log('Form has errors:', newErrors);
        }        
    };

    const handleUpdate = (e) => {
        const { name, value, type, checked } = e.target;
        // console.log("check is " + checked + " value is " + value + " type " + type)
        if (type === 'checkbox') {
            onUpdate(name, checked);
        } else if (name === 'coolingPeriod' || name === 'auction') {
            onUpdate(name, value === 'true');
        } else if (name === 'reportType') {
            onUpdate(name, value);
            if (value === 'Strata Report') {
                onUpdate('grannyFlat', false);
                onUpdate('numberBedrooms', null);
                updatePaymentSummary({ hasGrannyFlat: false, grannyFlatPrice: 0 });
            }
        } else {
            onUpdate(name, value);
        }
    };
    // console.log(formPurchase);
    
    const handleGrannyFlatChange = (e) => {
        const isSelected = e.target.value === 'yes';
        const { name, checked } = e.target;
        onUpdate(name, checked);
        setHasGrannyFlat(isSelected);
        updatePaymentSummary({ hasGrannyFlat: isSelected, grannyFlatPrice: isSelected ? 99 : 0 }); 
    };

    return (
        <div>
            <div className="property_form">                
                <div className="form_section">
                    <h1>Property Details</h1>
                    <hr style={{
                        background: '#DDD', 
                        width: '100%',
                        height: '1px', 
                        marginTop: '5%', 
                        marginBottom: '5%',
                        border: 'none',
                        }} 
                    />
                    <div>
                        {role === 'Partner' && (
                            <>
                                <label>What type of report are you ordering?</label>
                                <div className="selection">
                                    <label>
                                        <input
                                            type="radio" 
                                            name="reportType" 
                                            value="Pest Report"
                                            checked={formPurchase.reportType === "Pest Report"}
                                            onChange={handleUpdate}
                                            style={{ width: '1.2rem' }}
                                        /> Building & Pest Report
                                    </label>
                                    <label>
                                        <input 
                                            type="radio" 
                                            name="reportType" 
                                            value="Strata Report"
                                            checked={formPurchase.reportType === "Strata Report"}
                                            onChange={handleUpdate}
                                            style={{ width: '1.2rem' }}
                                        /> Strata Report
                                    </label>
                                </div>
                                {errors.reportType && <p style={{ color: 'red', fontSize: '0.875rem', marginTop: '0.5rem' }}>{errors.reportType}</p>}
                            </>
                        )}
                        <label>Do you have an offer accepted and a cooling off period?</label>
                        <div className="selection">
                            <label>
                                <input 
                                    type="radio"
                                    name="coolingPeriod"  
                                    value="true"
                                    checked={formPurchase.coolingPeriod === true}
                                    onChange={handleUpdate}
                                    style={{ width: '1.2rem' }}
                                /> Yes
                            </label>
                            <label>
                                <input 
                                    type="radio"  
                                    name='coolingPeriod'
                                    value="false"
                                    checked={formPurchase.coolingPeriod === false}
                                    onChange={handleUpdate}
                                    style={{ width: '1.2rem' }}
                                /> No
                            </label>
                        </div>
                        <label>Is the property going to auction?</label>
                        <div className="selection">
                            <label>
                                <input 
                                    type="radio" 
                                    name="auction" 
                                    value="true"
                                    checked={formPurchase.auction === true}
                                    onChange={handleUpdate}
                                    style={{ width: '1.2rem' }}
                                /> Yes
                            </label>
                            <label>
                                <input 
                                    type="radio" 
                                    name="auction" 
                                    value="false"
                                    checked={formPurchase.auction === false}
                                    onChange={handleUpdate}
                                    style={{ width: '1.2rem' }}
                                /> No
                            </label>
                        </div>
                        {role !== 'Partner' && !isReportOk && <label>How many bedrooms does the property have?</label>}
                        {role !== 'Partner' && !isReportOk && <div className="selection">
                            {['1', '2', '3', '4', '5', '6 or more'].map((bedroom) => (
                                <label key={bedroom}>
                                    <input 
                                        type="radio" 
                                        name="numberBedrooms" 
                                        value={bedroom}
                                        checked={formPurchase.numberBedrooms === bedroom}
                                        onChange={handleUpdate}
                                        style={{ width: '1.2rem' }}
                                    /> {bedroom}
                                </label>
                            ))}
                        </div>}
                        {role !== 'Partner' && <label>Does the property have an additional dwelling / granny flat?</label>}
                        {role !== 'Partner' && <div className="selection">
                            <label>
                                <input
                                    type="radio" 
                                    name="grannyFlat" 
                                    value="yes"
                                    checked={hasGrannyFlat === true}
                                    onChange={handleGrannyFlatChange}
                                    style={{ width: '1.2rem' }}
                                /> Yes
                            </label>
                            <label>
                                <input 
                                    type="radio" 
                                    name="grannyFlat" 
                                    value="no"
                                    checked={hasGrannyFlat === false}
                                    onChange={handleGrannyFlatChange}
                                    style={{ width: '1.2rem' }}
                                /> No
                            </label>
                        </div>}
                    </div>
                    {role !== 'Partner' && <label>Is there anything in particular you would like the inspector to look out for? (optional)</label>}
                    {role !== 'Partner' && <div>
                        <textarea
                            name='notes'
                            value={formPurchase.notes}
                            onChange={handleUpdate}
                            style={{
                                width: '90%',
                                height: '6.25rem',
                                padding: '5%',  
                                textAlign: 'left',
                                resize: 'none',
                                marginTop: '3%',
                                borderRadius: '1rem',
                                border: '1px solid #DDD',
                                outline: 'none',
                            }}
                        />
                    </div>}
                </div>
            </div>
            <YourDetailsForm 
                formPurchase={formPurchase} 
                onUpdate={onUpdate}
                validateCustomerField={validateCustomerField}
                errors={errors}
                setConfirmEmail={setConfirmEmail}
                role={role}
            />
            {role !== 'Partner' && <button onClick={handleCustomerClick} className='tostep2'>NEXT</button>}
            {role === 'Partner' && <button onClick={handlePartnerClick} className='tostep2'>NEXT</button>}
        </div>
    );
};

const StepTwo = ({ showStepThree, updatePaymentSummary, formPurchase, setFormPurchase, setClientSecret, summary, selectedServices, setSelectedServices, role }) => {
    // const [selectedServices,setSelectedServices] = useState([]);
    const [services,setServices] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);
    const [partnerStepErrors, setPartnerStepErrors] = useState({});
    const [partnerDocumentFiles, setPartnerDocumentFiles] = useState({});
    const navigate = useNavigate();
    const location = useLocation();
    const { price } = location.state || {};
    const isPartner = role === 'Partner';
    // console.log(price);
    const basePrice = isPartner ? PARTNER_BASE_PRICE : parseFloat(price || 0);
    const totalAmount = (basePrice + parseFloat(totalPrice) + parseFloat(summary.hasGrannyFlat ? 99 : 0)) * 100;
    const paymentAmount = isPartner ? PARTNER_BASE_PRICE * 100 : totalAmount;
    // console.log(totalAmount);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await FetchFunc(
                    '/service/all',
                    'GET',
                );
                if (response.status === '401') {
                    localStorage.setItem('isLoggedIn', false);
                    localStorage.removeItem('username');
                    localStorage.removeItem('role');
                    localStorage.removeItem('userId');
                    localStorage.removeItem('email');
                    localStorage.removeItem('mobile');
                    navigate('/login');
                } else if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                // console.log('Response from server:', response);
                const data = await response.json();
                // console.log('data response:', data);
                setServices(data);
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        };
        fetchServices();
    }, [navigate]);

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
    };

    const uploadPartnerDocument = async (file, documentType) => {
        if (file.size > PARTNER_DOCUMENT_MAX_BYTES) {
            throw new Error('File must be 10MB or smaller.');
        }

        const uploadData = new FormData();
        uploadData.append('file', file);
        uploadData.append('documentType', documentType);

        const response = await fetch(`${Backend_url}/oss/partner-order-document`, {
            method: 'POST',
            body: uploadData,
            credentials: 'include',
        });

        if (response.status === 401 || response.status === 403) {
            throw new Error('Please login as a partner before uploading documents.');
        }

        const data = await response.json();
        if (!response.ok || data.error) {
            throw new Error(data.error || `Document upload failed with status ${response.status}`);
        }

        return data;
    };

    const uploadRequiredPartnerDocuments = async () => {
        if (!isPartner || formPurchase.reportType !== 'Strata Report') {
            return {};
        }

        const documentFields = {};
        const uploadedFileState = {};

        if (partnerDocumentFiles.strataLevyNotice) {
            const strataDocument = await uploadPartnerDocument(partnerDocumentFiles.strataLevyNotice, 'STRATA_LEVY_NOTICE');
            documentFields.strataLevyNoticeFileName = strataDocument.fileName;
            documentFields.strataLevyNoticeFileKey = strataDocument.fileKey;
            uploadedFileState.strataLevyNotice = null;
        } else if (!formPurchase.strataLevyNoticeFileKey) {
            throw new Error('Strata Levy Notice is required.');
        }

        if (partnerDocumentFiles.authorityLetter) {
            const authorityDocument = await uploadPartnerDocument(partnerDocumentFiles.authorityLetter, 'AUTHORITY_LETTER');
            documentFields.authorityLetterFileName = authorityDocument.fileName;
            documentFields.authorityLetterFileKey = authorityDocument.fileKey;
            uploadedFileState.authorityLetter = null;
        } else if (!formPurchase.authorityLetterFileKey) {
            throw new Error('Authority Letter is required.');
        }

        if (Object.keys(uploadedFileState).length > 0) {
            setPartnerDocumentFiles((prevFiles) => ({
                ...prevFiles,
                ...uploadedFileState,
            }));
        }

        return documentFields;
    };

   const handleClick = async () => {
    if (isProcessingPayment) return; // Prevent double-clicks
    
    setIsProcessingPayment(true);
    try {
        const documentFields = await uploadRequiredPartnerDocuments();
        if (Object.keys(documentFields).length > 0) {
            setFormPurchase((prevFormPurchase) => ({
                ...prevFormPurchase,
                ...documentFields,
            }));
        }

        const dataToSend = {
            currency: 'aud',
            amount: paymentAmount,
            paymentMethod: 'card',
            ...formPurchase,
            ...documentFields,
            orderType: isPartner ? 'PARTNER' : (formPurchase.userId ? 'CUSTOMER' : 'GUEST'),
            reportType: isPartner ? getReportCode(formPurchase.reportType) : formPurchase.reportType,
        };

        const response = await fetch(`${Backend_url}/create-payment-intent`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend),
        });

        const data = await response.json().catch(() => null);
        if (!response.ok) {
            throw new Error(data?.message || data?.error || `HTTP error! status: ${response.status}`);
        }

        console.log('Payment intent response:', data); // Debug log

        if (!data) {
            throw new Error('No data received from server');
        }

        if (data.error) {
            console.error("Server error:", data.error, data.message);
            alert(`Payment error: ${data.message || 'Unknown error occurred'}`);
            return;
        }

        if (data.skipPayment === 'true') {
            // ✅ Backend created free order, no Stripe needed
            console.log("No payment required — order created");
            showStepThree({ skipPayment: true });
        } else if (data.clientSecret) {
            // ✅ Stripe needed — proceed with payment
            setClientSecret(data.clientSecret);
            showStepThree({ skipPayment: false });
        } else {
            console.error("Unexpected response from server:", data);
            alert('Unexpected response from server. Please try again.');
            return;
        }
        scrollToTop();
    } catch (error) {
        console.error('Error processing payment:', error);
        alert(error.message || 'Error processing payment. Please try again.');
    } finally {
        setIsProcessingPayment(false);
    }
};


    const calculateTotalPrice = (services) => {
        return services.reduce((sum, service) => sum + (service.price || 0), 0);
    };

    const handlePartnerFieldChange = (e) => {
        const { name, value, files } = e.target;
        if (files && files.length > 0) {
            const file = files[0];
            const isStrataLevyNotice = name === 'strataLevyNoticeFileName';
            const keyName = isStrataLevyNotice ? 'strataLevyNoticeFileKey' : 'authorityLetterFileKey';
            const fileStateKey = isStrataLevyNotice ? 'strataLevyNotice' : 'authorityLetter';
            if (file.size > PARTNER_DOCUMENT_MAX_BYTES) {
                setPartnerDocumentFiles((prevFiles) => ({
                    ...prevFiles,
                    [fileStateKey]: null,
                }));
                setFormPurchase((prevFormPurchase) => ({
                    ...prevFormPurchase,
                    [name]: '',
                    [keyName]: '',
                }));
                setPartnerStepErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: 'File must be 10MB or smaller.',
                }));
                e.target.value = '';
                return;
            }
            setPartnerDocumentFiles((prevFiles) => ({
                ...prevFiles,
                [fileStateKey]: file,
            }));
            setFormPurchase((prevFormPurchase) => ({
                ...prevFormPurchase,
                [name]: file.name,
                [keyName]: '',
            }));
            setPartnerStepErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
            return;
        }

        const nextValue = value;
        setFormPurchase((prevFormPurchase) => ({
            ...prevFormPurchase,
            [name]: nextValue,
        }));
        setPartnerStepErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const handlePartnerPreview = (e) => {
        e.preventDefault();
        const nextErrors = {};
        if (formPurchase.reportType === 'Strata Report') {
            if (!formPurchase.strataLevyNoticeFileName && !formPurchase.strataLevyNoticeFileKey) {
                nextErrors.strataLevyNoticeFileName = 'Strata Levy Notice is required for preview.';
            }
            if (!formPurchase.authorityLetterFileName && !formPurchase.authorityLetterFileKey) {
                nextErrors.authorityLetterFileName = 'Authority Letter is required for preview.';
            }
        }

        if (Object.keys(nextErrors).length > 0) {
            setPartnerStepErrors(nextErrors);
            return;
        }

        handleClick();
    };

    const handleGetService = (id, serviceData) => {
        setSelectedServices((prevSelectedServices) => {
            // let updatedServices;
            // if (prevSelectedServices.includes(id)) {
            //     updatedServices = prevSelectedServices.filter((serviceId) => serviceId !== id);
            // } else {
            //     updatedServices = [...prevSelectedServices, id];
            // }            
            
            let updatedServices;
            if (prevSelectedServices.some((service) => service.serviceId === id)) {
                // Remove the service if it already exists
                updatedServices = prevSelectedServices.filter((service) => service.serviceId !== id);
            } else {
                // Add the full service object if it doesn't exist
                const newService = serviceData.find((service) => service.serviceId === id);
                if (newService) {
                    updatedServices = [...prevSelectedServices, newService];
                } else {
                    updatedServices = prevSelectedServices; // No change if service not found
                }
            }
            
            const updatedServiceIds = updatedServices.map((service) => service.serviceId);

            setFormPurchase((prevFormPurchase) => ({
                ...prevFormPurchase,
                services: updatedServiceIds, // Update service with IDs only
            }));            
            
            const totalPrice = calculateTotalPrice(updatedServices); // Calculate the total price
            updatePaymentSummary({
                getService: updatedServices, // Update the list of services
                servicePrice: totalPrice, // Update the total price
            });
            setTotalPrice(totalPrice);            
            
            return updatedServices;
            
        });
        // updatePaymentSummary({ getService: selected, servicePrice: selected ? 0 : 0 });
    };
    // console.log(formPurchase)
    // console.log(selectedServices)
    return (
        <div>
            <div className="service_details">
                <h1>{isPartner ? 'Report Requirements' : 'Addition Service'}</h1>
                <hr style={{
                    background: '#DDD', 
                    width: '100%', 
                    marginTop: '5%', 
                    marginBottom: '5%',
                    border: 'none',
                    height: '1px'
                    }} 
                />
                {isPartner && formPurchase.reportType === 'Pest Report' && (
                    <div className="partner_requirement_panel">
                        <div className="partner_eta_strip">
                            <span>Building workflow</span>
                            <strong>ETA: {getReportEta(formPurchase.reportType)}</strong>
                        </div>
                        <label>How many bedrooms does the property have?</label>
                        <div className="selection">
                            {['1', '2', '3', '4', '5', '6 or more'].map((bedroom) => (
                                <label key={bedroom}>
                                    <input 
                                        type="radio" 
                                        name="numberBedrooms" 
                                        value={bedroom}
                                        checked={formPurchase.numberBedrooms === bedroom}
                                        onChange={handlePartnerFieldChange}
                                        style={{ width: '1.2rem' }}
                                    /> {bedroom}
                                </label>
                            ))}
                        </div>
                        <label>Does the property have an additional dwelling / granny flat?</label>
                        <div className="selection">
                            <label>
                                <input
                                    type="radio" 
                                    name="grannyFlat" 
                                    value="true"
                                    checked={formPurchase.grannyFlat === true}
                                    onChange={() => {
                                        setFormPurchase((prevFormPurchase) => ({ ...prevFormPurchase, grannyFlat: true }));
                                        updatePaymentSummary({ hasGrannyFlat: true, grannyFlatPrice: 99 });
                                    }}
                                    style={{ width: '1.2rem' }}
                                /> Yes
                            </label>
                            <label>
                                <input 
                                    type="radio" 
                                    name="grannyFlat" 
                                    value="false"
                                    checked={formPurchase.grannyFlat === false}
                                    onChange={() => {
                                        setFormPurchase((prevFormPurchase) => ({ ...prevFormPurchase, grannyFlat: false }));
                                        updatePaymentSummary({ hasGrannyFlat: false, grannyFlatPrice: 0 });
                                    }}
                                    style={{ width: '1.2rem' }}
                                /> No
                            </label>
                        </div>
                        <label>Anything you would like the inspector to look out for? (optional)</label>
                        <textarea
                            name="notes"
                            value={formPurchase.notes}
                            onChange={handlePartnerFieldChange}
                            className="partner_notes"
                        />
                    </div>
                )}
                {isPartner && formPurchase.reportType === 'Strata Report' && (
                    <div className="partner_requirement_panel">
                        <div className="partner_eta_strip">
                            <span>Strata document review</span>
                            <strong>ETA: {getReportEta(formPurchase.reportType)}</strong>
                        </div>
                        <div className="strata_upload_grid">
                            <label className={`strata_upload_box ${formPurchase.strataLevyNoticeFileName ? 'has_file' : ''}`}>
                                <span className="upload_box_topline">
                                    <span className="upload_box_heading">Strata Levy Notice</span>
                                    <span className="required_badge">Required</span>
                                </span>
                                <input
                                    type="file"
                                    name="strataLevyNoticeFileName"
                                    accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                                    onChange={handlePartnerFieldChange}
                                />
                                <small>{formPurchase.strataLevyNoticeFileName || 'PDF, JPG or PNG'}</small>
                                {partnerStepErrors.strataLevyNoticeFileName && <em>{partnerStepErrors.strataLevyNoticeFileName}</em>}
                            </label>
                            <div className="authority_document_group">
                                <div className="authority_group_header">
                                    <strong>Authority Letter</strong>
                                    <span className="required_badge">Required</span>
                                </div>
                                <label className={`strata_upload_box authority_upload_box ${formPurchase.authorityLetterFileName ? 'has_file' : ''}`}>
                                    <input
                                        type="file"
                                        name="authorityLetterFileName"
                                        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                                        onChange={handlePartnerFieldChange}
                                    />
                                    <small>{formPurchase.authorityLetterFileName || 'PDF, JPG or PNG'}</small>
                                    {partnerStepErrors.authorityLetterFileName && <em>{partnerStepErrors.authorityLetterFileName}</em>}
                                </label>
                                <a
                                    className="template_download_preview"
                                    href={authorityLetterTemplate}
                                    download
                                >
                                    <span className="template_download_icon" aria-hidden="true"></span>
                                    <span className="template_download_copy">
                                        <strong>Download template</strong>
                                        <small>Letter of Authority - DOCX</small>
                                    </span>
                                </a>
                                <p className="authority_template_scope">
                                    For strata records access: meeting minutes, financials, insurance, defects and by-laws.
                                </p>
                            </div>
                        </div>
                        <label>Anything else you would like us to know? (optional)</label>
                        <textarea
                            name="notes"
                            value={formPurchase.notes}
                            onChange={handlePartnerFieldChange}
                            className="partner_notes"
                        />
                    </div>
                )}
                {isPartner && <div className="addition">Additional Services</div>}
                {Array.isArray(services) && services.map((service) => (
                    <div 
                        key={service.serviceId}
                        onClick={() => handleGetService(service.serviceId, services)}
                        style={{
                            background: selectedServices.some((selected) => selected.serviceId === service.serviceId)
                                ? 'rgba(0, 130, 134, 0.17)'
                                : '#F9F8F8',
                            border: selectedServices.some((selected) => selected.serviceId === service.serviceId)
                                ? '1px solid #008286'
                                : 'none',
                            borderRadius: '1rem',
                            width: '95%',
                            marginBottom: '5%',
                            paddingLeft: '5%',
                            cursor: 'pointer',
                        }}
                    >
                        <h1>{service.title}</h1>
                        <p>{service.description}</p>
                    </div>
                ))}
                {isPartner && (
                    <div className="discount_preview">
                        <label>Discount code</label>
                        <div>
                            <input type="text" placeholder="Discount code" disabled />
                            <button type="button" disabled>Apply</button>
                        </div>
                        <p>Discount codes coming soon.</p>
                    </div>
                )}
            </div>
            {role === 'Partner' && <button 
                onClick={handlePartnerPreview}
                className='tostep3'
                disabled={isProcessingPayment}
            >
                {isProcessingPayment ? 'PROCESSING...' : 'NEXT'}
            </button>}
            {role !== 'Partner' && <button
                onClick={handleClick}
                className='tostep3'
                disabled={isProcessingPayment}
            >
                {isProcessingPayment ? 'PROCESSING...' : 'NEXT'}
            </button>}
        </div>
    );
};

const StepThree = ({ clientSecret, skipPayment, previewPayment, formPurchase }) => {
    if (previewPayment) {
        return (
            <div className="payment_detail partner_payment_preview">
                <div className="preview_badge">Stripe checkout</div>
                <h1>Partner payment</h1>
                <p>
                    Partner card payment is routed through Stripe.
                </p>
                <div className="preview_payment_rows">
                    <div>
                        <span>Report type</span>
                        <strong>{getReportLabel(formPurchase.reportType)}</strong>
                    </div>
                    <div>
                        <span>Estimated turnaround</span>
                        <strong>{getReportEta(formPurchase.reportType)}</strong>
                    </div>
                    <div>
                        <span>Base price</span>
                        <strong>${PARTNER_BASE_PRICE}</strong>
                    </div>
                </div>
                <button type="button" disabled>Waiting for payment details</button>
                <small>Open this page on localhost or HTTPS to enter card details.</small>
            </div>
        );
    }

    return (
        <div>
            {skipPayment ? (
                <div className="payment_detail">
                    <h1>No Payment Required</h1>
                    <p>Your order has been placed without any payment.</p>
                </div>
            ) : (
                <Payment clientSecret={clientSecret} />
            )}
        </div>
    );
};


const PaymentSummary = ({ summary, role, purchaseFlow }) => {
    const location = useLocation();
    const { address, query, price } = location.state || {};
    const formPurchase = JSON.parse(sessionStorage.getItem("formPurchase") || '{}');
    const isPartner = role === 'Partner';
    const isExistingReportPurchase = purchaseFlow === 'EXISTING_REPORT';
    const basePrice = isPartner ? PARTNER_BASE_PRICE : parseFloat(price || 0);
    const totalAmount = isPartner ? basePrice : basePrice + parseFloat(summary.hasGrannyFlat ? 99 : 0) + parseFloat(summary.servicePrice || 0);
    const availabilityText = isPartner
        ? `ETA: ${getReportEta(formPurchase.reportType)}`
        : isExistingReportPurchase
            ? 'Report available now!'
            : 'Report to be arranged after payment';

    return (
        <div className="order_summary">
            <h3>Order Summary</h3>
            <div className="address">
                <p>{query || address}</p>
            </div>
            <hr style={{
                background: '#DDD', 
                width: '100%', 
                marginTop: '5%', 
                marginBottom: '5%',
                border: 'none',
                height: '1px'
                }} 
            />
            <div>
                <div className="calculation">
                    <p>{getReportLabel(formPurchase.reportType)}</p><span>${basePrice}</span>
                </div>
                <div className={isPartner ? "report_available partner_preview_notice" : "report_available"}>
                    <img src={check} alt="check" />
                    <h4>{availabilityText}</h4>
                </div>
                {summary.hasGrannyFlat && (
                    <div className="calculation">
                        <p>Second Dwelling / Granny Flat</p><span>$99</span>
                    </div>
                )}
            </div>
            <div>
                <div className="addition">Additional Services</div>
                {summary.getService && summary.getService.map(item => (
                    //  <div className="calculation2"><p>{item.title}</p><span>{item.price}</span></div>
                    <div className="calculation2" key={item.serviceId}>
                        <p>{item.title}</p>
                        <span>{isPartner ? 'Preview' : `$${item.price}`}</span>
                    </div>
                ))}
            </div>
            <hr style={{
                background: '#DDD', 
                width: '100%', 
                marginTop: '5%', 
                marginBottom: '5%',
                border: 'none',
                height: '1px'
                }} 
            />
            <div className="total"><h4>Total <p>(GST Inc)</p>:</h4><h5>${totalAmount}</h5></div>
            {isPartner && <p className="summary_preview_note">Partner payment is collected securely by Stripe.</p>}
        </div>
    );
};

const PurchasePage = () => {
    const id = localStorage.getItem('userId');
    const location = useLocation();
    const navigate = useNavigate();
    const roleFromSearch = getRoleFromSearch(location.search);
    if (roleFromSearch) {
        localStorage.setItem('role', roleFromSearch);
        localStorage.setItem('isLoggedIn', 'true');
    }
    const storedRole = roleFromSearch || localStorage.getItem('role');
    const [skipPayment, setSkipPayment] = useState(false);
    const { query, address, googlePlaceId, purchaseFlow } = location.state || {};
    const isKnownPurchaseFlow = purchaseFlow === 'EXISTING_REPORT' || purchaseFlow === 'NEW_REPORT';
    const hasPurchaseContext = isKnownPurchaseFlow && Boolean(address || query);
    const isExistingReportPurchase = purchaseFlow === 'EXISTING_REPORT';
    const isPartnerBuyingExistingReport = storedRole === 'Partner' && isExistingReportPurchase;
    const role = isPartnerBuyingExistingReport ? null : storedRole;
    const purchaseUserId = isPartnerBuyingExistingReport ? null : id;
    const [selectedServices,setSelectedServices] = useState([]);
    const [formPurchase,setFormPurchase] = useState({
        propertyAddress: address || query || null,
        coolingPeriod: false,
        auction: false,
        numberBedrooms: null,
        grannyFlat: false,
        notes: '',
        firstName: null,
        lastName: null,
        email: null,
        mobile: null,
        homeAddress: null,
        secondContact: null,
        secondFirstName: null,
        secondLastName: null,
        firstTimeBuyer: false,
        agentFirstName: null,
        agentLastName: null,
        agentEmail: null,
        agentMobile: null,
        userId: purchaseUserId,
        services: [],
        reportType: null,
        googlePlaceId: googlePlaceId || null,
        strataLevyNoticeFileName: '',
        strataLevyNoticeFileKey: '',
        authorityLetterFileName: '',
        authorityLetterFileKey: '',
    });

    const handleUpdate = (key, value) => {
        setFormPurchase((prevData) => ({
            ...prevData,
            [key]: value,
        }));
    };

    const [currentStep, setCurrentStep] = useState(1);
    const [clientSecret, setClientSecret] = useState('');
    const [previewPayment, setPreviewPayment] = useState(false);
    const [paymentSummary, setPaymentSummary] = useState({
        hasGrannyFlat: false,
        grannyFlatPrice: 0,
        getService: [],
        servicePrice: 0,
    });
    const pageReportLabel = role === 'Partner' ? getReportLabel(formPurchase.reportType) : 'Building & Pest Report';

    useEffect(() => {
        if (!hasPurchaseContext) {
            sessionStorage.removeItem('formPurchase');
            navigate('/', { replace: true });
        }
    }, [hasPurchaseContext, navigate]);

    const showStepTwo = () => {
        setPreviewPayment(false);
        setSkipPayment(false);
        setCurrentStep(2);
    };
    const showStepThree = (options = {}) => {
        const { skipPayment = false, previewPayment = false } = options;
        setSkipPayment(skipPayment);
        setPreviewPayment(previewPayment);
        setCurrentStep(3);
    };
    const showStepOne = () => {
        setPreviewPayment(false);
        setSkipPayment(false);
        setCurrentStep(1);
    };

    const updatePaymentSummary = (newSummary) => {
        setPaymentSummary((prevSummary) => ({ ...prevSummary, ...newSummary }));
    };

    // console.log(paymentSummary);

    const handleBack = () => {
        navigate(-1);
    };
    
    sessionStorage.setItem("formPurchase", JSON.stringify(formPurchase));

    if (!hasPurchaseContext) {
        return null;
    }

    return (
        <div className='purchase1'>
            <Header />
            <div className='header_bg'></div>
            {currentStep === 1 && (                
                <button className='back' onClick={handleBack}>
                        <div className='back_text'>
                            <img src={back} alt='back' />
                            <p>Back</p>
                        </div>
                </button>
            )}
            {currentStep === 2 && (                
                <button onClick={showStepOne} className='back'>
                    <div className='back_text'>
                        <img src={back} alt='back' />
                        <p>Back</p>
                    </div>
                </button>                
            )}
            {currentStep === 3 && (                
                <button onClick={showStepTwo} className='back'>
                    <div className='back_text'>
                        <img src={back} alt='back' />
                        <p>Back</p>
                    </div>
                </button>
            )}
            <div className='report_title'>{pageReportLabel}</div>
            <div className='step_progress'>
                <div className="step">
                    <div className="step-number">1</div>
                    <div className="step-label">Required Details</div>
                </div>
                <div className="step" 
                    style={{
                        background: currentStep === 1 ? '#F2F2F2' : '#fff',
                    }}
                >
                    <div className="step-number" 
                        style={{
                            background: currentStep === 1 ? '#A4A4A4' : '#008286',
                        }}
                    >2</div>
                    <div className="step-label"
                        style={{
                            color: currentStep === 1 ? '#A4A4A4' : '#343434',
                        }}
                    >{role === 'Partner' ? 'Requirements' : 'Additional Services'}</div>
                </div>
                <div className="step" 
                    style={{
                        background: currentStep === 3 ? '#fff' : '#F2F2F2',
                    }}
                >
                    <div className="step-number"
                        style={{
                            background: currentStep === 3 ? '#008286' : '#A4A4A4',
                        }}
                    >3</div>
                    <div className="step-label" 
                        style={{
                            color: currentStep === 3 ? '#343434' : '#A4A4A4',
                        }}
                    >Payment</div>
                </div>
            </div>
            <div className='payment_steps'>
                {role === 'Admin' && <h1>Not Available</h1>}
                {role === 'Partner' && 
                    <div className='payment_choice'>                        
                        {currentStep === 1 && 
                            <StepOne 
                                showStepTwo={showStepTwo} 
                                updatePaymentSummary={updatePaymentSummary}
                                formPurchase={formPurchase} 
                                onUpdate={handleUpdate}
                                setFormPurchase={setFormPurchase}
                                role={role}
                            />
                        }
                        {currentStep === 2 && (
                            <StepTwo showStepThree={showStepThree} 
                                showStepOne={showStepOne} 
                                updatePaymentSummary={updatePaymentSummary}
                                formPurchase={formPurchase} 
                                onUpdate={handleUpdate}
                                setFormPurchase={setFormPurchase}
                                setClientSecret={setClientSecret}
                                clientSecret={clientSecret}
                                summary={paymentSummary}
                                selectedServices={selectedServices}
                                setSelectedServices={setSelectedServices}
                                role={role}
                            />
                        )}
                        {currentStep === 3 && 
                            <StepThree showStepTwo={showStepTwo} 
                                showStepOne={showStepOne}
                                updatePaymentSummary={updatePaymentSummary}
                                formPurchase={formPurchase} 
                                onUpdate={handleUpdate}
                                setFormPurchase={setFormPurchase} 
                                skipPayment={skipPayment}
                                previewPayment={previewPayment}
                                clientSecret={clientSecret}
                            />
                        }
                    </div>
                }
                {(role === 'Customer' || role == null) &&
                    <div className='payment_choice'>
                        {currentStep === 1 && 
                            <StepOne 
                                showStepTwo={showStepTwo} 
                                updatePaymentSummary={updatePaymentSummary}
                                formPurchase={formPurchase} 
                                onUpdate={handleUpdate}
                                setFormPurchase={setFormPurchase}
                                role={role}
                            />
                        }
                        {currentStep === 2 && (
                            <StepTwo showStepThree={showStepThree} 
                                showStepOne={showStepOne}
                                updatePaymentSummary={updatePaymentSummary}
                                formPurchase={formPurchase} 
                                onUpdate={handleUpdate}
                                setFormPurchase={setFormPurchase}
                                setClientSecret={setClientSecret} 
                                clientSecret={clientSecret}
                                summary={paymentSummary}
                                selectedServices={selectedServices}
                                setSelectedServices={setSelectedServices}
                                role={role}
                            />
                        )}
                        {currentStep === 3 &&                      
                            <StepThree showStepTwo={showStepTwo} 
                                showStepOne={showStepOne}
                                updatePaymentSummary={updatePaymentSummary}
                                formPurchase={formPurchase} 
                                onUpdate={handleUpdate}
                                setFormPurchase={setFormPurchase}
                                clientSecret={clientSecret}
                            />                    
                        }
                    </div>
                }                
                {role !== 'Admin' && <div className='payment_summary'>
                    <PaymentSummary summary={paymentSummary} role={role} purchaseFlow={purchaseFlow} />
                </div>}
            </div>
        </div>   
    );
};

export default PurchasePage;
